import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import NotificationBannerSkeleton from './NotificationBannerSkeleton';
const TradeQuotesBanner = t0 => {
  const $ = _c(3);
  const {
    type,
    quote_id: t1
  } = t0;
  const quote_id = t1 === undefined ? "" : t1;
  let title;
  let body;
  bb0: switch (type) {
    case "CREATE_QUOTE":
      {
        title = "Success!";
        body = "Your quote has been created successfully";
        break bb0;
      }
    case "ARCHIVE_QUOTE":
      {
        title = "Success!";
        body = `Quote ${quote_id} has been archived successfully`;
        break bb0;
      }
    case "REFRESH_QUOTE":
      {
        title = "Success!";
        body = `Quote ${quote_id} has been refreshed successfully`;
        break bb0;
      }
    default:
  }
  let t2;
  if ($[0] !== body || $[1] !== title) {
    t2 = <NotificationBannerSkeleton title={title} body={body} />;
    $[0] = body;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
TradeQuotesBanner.propTypes = {
  type: PropTypes.oneOf(['CREATE_QUOTE', 'ARCHIVE_QUOTE', 'REFRESH_QUOTE']),
  quote_id: PropTypes.string
};
export default TradeQuotesBanner;